const existingMyneofintechEmails = [
  'myappcontact',
  'mycontact',
  'mysupport',
  'myinfo',
  'neoappcontact',
  'neocontact',
  'neosupport',
  'neoinfo',
  'neomanager',
  'newappcontact',
  'newcontact',
  'newsupport',
  'newinfo',
  'newmanager',
  'ecobanka.conferences',
  'ecobankaconferences',
  'mymanager',
  'myneo.ecobanka',
  'invitations',
  'myreserve.ecobanka',
  'bigdata',
  'news',
  'careers',
  'demomanager',
  'catchall'
]
export default existingMyneofintechEmails
